import React, { useState, useEffect, useRef } from "react";
import "./BackgroundCarousel.css";
import { backgroundImages } from "./backgroundImages";

const BackgroundCarousel = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const intervalRef = useRef<NodeJS.Timeout | undefined>(undefined);
  const timeoutRef = useRef<NodeJS.Timeout | undefined>(undefined);

  useEffect(() => {
    if (backgroundImages.length <= 1) return;

    // Function to advance to next image
    const advanceImage = () => {
      setCurrentIndex((prev) => (prev + 1) % backgroundImages.length);
    };

    // Set up the interval to change images
    intervalRef.current = setInterval(advanceImage, 10000);

    // Cleanup on unmount
    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, []);

  if (backgroundImages.length === 0) {
    return null;
  }

  return (
    <div className="background-carousel">
      {backgroundImages.map((bgConfig, index) => {
        const isMobile = window.innerWidth <= 768;
        const position = isMobile
          ? bgConfig.mobilePosition
          : "center center";

        return (
          <div
            key={bgConfig.filename}
            className={`background-image ${
              index === currentIndex ? "active" : ""
            }`}
            style={{
              backgroundImage: `url(/backgrounds/${encodeURIComponent(bgConfig.filename)})`,
              backgroundPosition: position
            }}
          />
        );
      })}
    </div>
  );
};

export default BackgroundCarousel;
